import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import type { BookV1 } from '@ilteducation/content-registry-types';
import type { Language } from '@ilteducation/content-ref-data-types';
import useUploadMedia from '@/comp/use-upload-media';
import useMediaFormFeature from '@/comp/use-media-form-feature';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import DropFile from '@/components/base/DropFile.vue';
import BookAudioCopyPaste from '@/components/book/BookAudioCopyPaste.vue';
import { useRefLanguages } from '@/comp/use-ref-languages';

type Props = {
  id: string;
  item?: BookV1;
  title?: string;
  allowedFileNames?: string[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'BookAudioUploader',
  props: {
    id: null,
    item: null,
    title: null,
    allowedFileNames: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  item?: BookV1;
  title?: string;
  allowedFileNames?: string[];
}

const dropFileRef = ref<InstanceType<typeof DropFile> | null>(null);
const files = ref<File[]>([]);
const selectedLang = ref<Language>();


const { uploadInProgress, uploadBulk } = useUploadMedia();
const { removeMedia } = useMediaFormFeature(props.item);
const upload = async () => {
  await uploadBulk(props.id, files.value, { subType: 'audio', language: selectedLang.value?.languageCode });
  dropFileRef.value?.clearFiles();
};
const removeAudio = async (language: string) => {
  await removeMedia({ subType: 'audio', language });
};

const { languages: availableLanguages } = useRefLanguages();

const rules = {
  required: (value: unknown) => !!value || 'This field is required',
};

const getLanguageText = (code: string) =>
  availableLanguages.value?.find((l) => l.languageCode === code)?.language || code;

const updateFiles = (dataFiles: File[]) => {
  files.value = dataFiles;
};

const uploadDisabled = computed(
  () => !(files.value.length === props.allowedFileNames?.length && selectedLang.value !== undefined),
);

return { __sfc: true,dropFileRef, files, selectedLang, props, uploadInProgress, uploadBulk, removeMedia, upload, removeAudio, availableLanguages, rules, getLanguageText, updateFiles, uploadDisabled, DisableableButton, DropFile, BookAudioCopyPaste }
}

})